let activeUnauthorizedRedirects = 0;

const FALLBACK_RELEASE_MS = 5000;

/**
 * 標記目前正在處理未授權導頁。
 *
 * 401 仍會 reject，讓原呼叫端的 finally 正常清理狀態；但在導頁完成前，
 * 舊頁面的 catch 不應再顯示錯誤訊息。
 */
export function beginUnauthorizedRedirect() {
  activeUnauthorizedRedirects += 1;

  let released = false;
  let releaseScheduled = false;

  const releaseNow = () => {
    if (released) return;
    released = true;
    activeUnauthorizedRedirects = Math.max(0, activeUnauthorizedRedirects - 1);
  };

  const fallbackTimer = setTimeout(releaseNow, FALLBACK_RELEASE_MS);

  return () => {
    if (released || releaseScheduled) return;
    releaseScheduled = true;
    clearTimeout(fallbackTimer);

    // 讓同一個 401 promise chain 的 catch 先執行，再解除訊息抑制。
    setTimeout(releaseNow, 0);
  };
}

export function isUnauthorizedRedirectInProgress() {
  return activeUnauthorizedRedirects > 0;
}
